import { createRouter, createWebHistory } from 'vue-router';
import CharacterSelection from './components/CharacterSelection.vue';
import Game from './components/Game.vue';

const routes = [
  {
    path: '/',
    name: 'CharacterSelection',
    component: CharacterSelection
  },
  {
    path: '/game',
    name: 'Game',
    component: Game
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;